import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import AsyncSelect from 'react-select/lib/Async';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import ModalContactPost from '../components/modal/modalContactPost';
import ModalConfirm from '../components/modal/modalConfirm';

import bookIcon from 'src/images/icons/003-book.svg';
import clerkWithTieIcon from 'src/images/icons/002-clerk-with-tie.svg';
import dealIcon from 'src/images/icons/001-deal.svg';
import ringAnim from 'src/images/anim/ring.svg';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';
import Deals from './scenes/Deals';

const apiContact = '/api/contact/';
const apiCustomer = '/api/customer/';
const apiEmployeeShow = '/api/employee/';
const apiOrigin = '/api/origin/';
const apiProFields = '/api/customer/profield/';
const apiCustomerShow = '/api/customer/';

const linkToContact = '/dashboard/contact/';
const linkToCustomer = '/dashboard/customer/';
const linkToUser = '/dashboard/user/';

class Book extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      offsetContact: 0,
      offsetCustomer: 0,
      loading: false,
      selectedView: 1,
      isModalPostContactOpen: false,
      isModalDeleteContactOpen: false,
      isModalDeleteCustomerOpen: false,
      contactToDeleteId: undefined,
      customerToDeleteId: undefined,
      textModal: {
        title: 'default title',
        message: 'default message',
      },
      entity: undefined,
      dataContact: undefined,
      dataCustomer: undefined,
      dataEmployee: undefined,
      dataOrigin: undefined,
      // CONTACT /////////////////////////////////////////////
      searchContactName: '',
      searchContactDateCreateStart: null,
      searchContactDateCreateEnd: null,
      searchContactPhone: '',
      searchContactEmail: '',
      searchContactJob: '',
      searchContactCompanyName: '',
      searchContactAgencyId: -1,
      searchContactOrigin: '',
      searchContactOrigins: [],
      searchContactCreator: '',
      searchContactCreators: [],
      // CUSTOMER ////////////////////////////////////////////
      searchCustomerSocialReason: '',
      searchCustomerDateCreateStart: null,
      searchCustomerDateCreateEnd: null,
      searchCustomerTermination: false,
      searchCustomerLiquidation: false,
      searchCustomerProfessionalField: '',
      searchCustomerProfessionalFields: [],
      searchCustomerCreator: '',
      searchCustomerCreators: [],
      searchCustomerAgencyId: -1,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleInputSelectMultiChange = this.handleInputSelectMultiChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModalDeleteContact = this.openModalDeleteContact.bind(this);
    this.openModalDeleteCustomer = this.openModalDeleteCustomer.bind(this);
    this.postResult = this.postResult.bind(this);
    this.deleteContact = this.deleteContact.bind(this);
    this.deleteCustomer = this.deleteCustomer.bind(this);
    this.refreshSearchContact = this.refreshSearchContact.bind(this);
    this.refreshSearchCustomer = this.refreshSearchCustomer.bind(this);
    this.seeMore = this.seeMore.bind(this);
    this.filter = this.filter.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.isDateIntervalNull = this.isDateIntervalNull.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleInputSelectChange(stateName, val) {
    const value = val ? val['id'] : -1;

    this.setState({
      [stateName]: value,
    });
  }
  handleInputSelectMultiChange(stateName, val) {
    this.setState({
      [stateName]: val,
      [stateName + 's']: val,
    });
  }
  handleDateChange(stateName, value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      [stateName]: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  filterSelect(option, filter) {
    let res = true;

    if (filter.trim() !== '') {
      let arrayToSearch = option['label'].split(' ');
      let arrayKeywords = filter.split(' ');

      function searchLikeGoogle(arr, val) {
        return arr.some(function (arrVal) {
          return (
            arrVal
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .indexOf(
                val
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
              ) === 0
          );
        });
      }

      for (let i = 0; i < arrayKeywords.length; i++) {
        if (!searchLikeGoogle(arrayToSearch, arrayKeywords[i])) {
          res = false;
        }
      }
    }

    return res;
  }

  asyncEmployee(input) {
    let queryURL = apiEmployeeShow;

    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;

    return this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let dataToMap = data['data']['employees'];

          let mapped = dataToMap.map((p) => {
            return {
              ...p,
              value: p['id'],
              label: p['firstname'] + ' ' + p['lastname'],
            };
          });

          return { options: mapped, complete: true };
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search async: \n' + error);
          return { options: [], complete: true };
        }.bind(this)
      );
  }
  asyncCustomer(input) {
    let queryURL = apiCustomerShow;

    /*
            The graphQl
        */
    let graphQL =
      '{ customers(socialReasonOperator: "Contient", socialReason:"' +
      input +
      '"){ items{ id, installationSite{ socialReason } } } }';
    queryURL += graphQL;

    return this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let dataToMap = data['data']['customers']['items'];

          let mapped = dataToMap.map((p) => {
            return {
              ...p,
              value: p['id'],
              label: p['installationSite']['socialReason'],
            };
          });

          return { options: mapped, complete: true };
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search async: \n' + error);
          return { options: [], complete: true };
        }.bind(this)
      );
  }

  asyncProfessionalField(input) {
    let queryURL = apiProFields;
    let graphQL = '{ professionalFields{ id, wording } }';
    queryURL += graphQL;

    return this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let dataToMap = data['data']['professionalFields'];

          let mapped = dataToMap.map((p) => {
            return {
              ...p,
              value: p['id'],
              label: p['wording'],
            };
          });

          return { options: mapped, complete: true };
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search async: \n' + error);
          return { options: [], complete: true };
        }.bind(this)
      );
  }
  asyncOrigin = (input) => {
    let queryURL = apiOrigin;
    let graphQL = '{ origins{ id, labelOrigin } }';
    queryURL += graphQL;

    return this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let dataToMap = data['data']['origins'];

          let mapped = dataToMap.map((p) => {
            return {
              ...p,
              value: p['id'],
              label: p['labelOrigin'],
            };
          });

          return { options: mapped, complete: true };
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search async: \n' + error);
          return { options: [], complete: true };
        }.bind(this)
      );
  };

  componentDidMount() {
    this.refreshSearchContact(0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedView !== this.state.selectedView) {
      switch (this.state.selectedView) {
        case 1: // Contact
          this.refreshSearchContact(0);
          break;
        case 2: // Customer
          this.refreshSearchCustomer(0);
          break;
      }
    }
  }

  sanitizeText = (text) => {
    return text && text.trim() !== '' ? text : null;
  };
  sanitizeDate = (date) => {
    return date ? '"' + moment(date).format('YYYY-MM-DD') + '"' : null;
  };
  sanitizeArray = (array) => {
    return array && array.length > 0
      ? JSON.stringify(
          array.map((p) => {
            return p['id'];
          })
        )
      : null;
  };

  isDateIntervalNull(type, info = null) {
    let start = null;
    let end = null;

    // TODO -> ADD all the dates
    switch (this.state.selectedView) {
      case 1: // Contact
        switch (info) {
          case 'create':
            start = this.state.searchContactDateCreateStart;
            end = this.state.searchContactDateCreateEnd;
            break;
        }
        break;
      case 2: // Customer
        switch (info) {
          case 'create':
            start = this.state.searchCustomerDateCreateStart;
            end = this.state.searchCustomerDateCreateEnd;
            break;
        }
        break;
    }

    return start || end ? '"Est entre"' : null;
  }

  getGraphQL = (type, offsetNb = 0) => {
    let res = '';
    let search = undefined;

    switch (this.state.selectedView) {
      case 1: // Contact
        search = {
          name: this.sanitizeText(this.state.searchContactName),
          phone: this.sanitizeText(this.state.searchContactPhone),
          email: this.sanitizeText(this.state.searchContactEmail),
          job: this.sanitizeText(this.state.searchContactJob),
          companyName: this.sanitizeText(this.state.searchContactCompanyName),
          dateCreateStart: this.sanitizeDate(this.state.searchContactDateCreateStart),
          dateCreateEnd: this.sanitizeDate(this.state.searchContactDateCreateEnd),
          dateCreateOperator: this.isDateIntervalNull(type, 'create'),
          creatorIds: this.sanitizeArray(this.state.searchContactCreators),
          originIds: this.sanitizeArray(this.state.searchContactOrigins),
          agencyId: this.state.searchContactAgencyId,
        };
        res =
          '{contacts(' +
          'lastname:' +
          search.name +
          ', lastnameOperator:Contient, ' +
          'phone:' +
          search.phone +
          ', phoneOperator:Contient, ' +
          'email:' +
          search.email +
          ', emailOperator:Contient, ' +
          'job:' +
          search.job +
          ', jobOperator:Contient, ' +
          'companyName:' +
          search.companyName +
          ', companyNameOperator:Contient, ' +
          'dateCreateStart:' +
          search.dateCreateStart +
          ', dateCreateEnd:' +
          search.dateCreateEnd +
          ', dateCreateOperator:' +
          search.dateCreateOperator +
          ', ' +
          ', creatorIdsOperator: "Fait partie de", creatorIds:' +
          search.creatorIds +
          ', originIdsOperator: "Fait partie de", originIds:' +
          search.originIds +
          ', agencyId:' +
          search.agencyId +
          ', offset:' +
          itemsPerPage['book'] * offsetNb +
          ', limit:' +
          itemsPerPage['book'] +
          '){ hasMore, items{ id, name, lastname, dateCreate, origin{ id, labelOrigin}, creator{ user{ id, username } } } } }';
        break;
      case 2: // Customer
        search = {
          socialReason: this.sanitizeText(this.state.searchCustomerSocialReason),
          dateCreateStart: this.sanitizeDate(this.state.searchCustomerDateCreateStart),
          dateCreateEnd: this.sanitizeDate(this.state.searchCustomerDateCreateEnd),
          dateCreateOperator: this.isDateIntervalNull(type, 'create'),
          termination: this.state.searchCustomerTermination,
          liquidation: this.state.searchCustomerLiquidation,
          professionalFieldIds: this.sanitizeArray(this.state.searchCustomerProfessionalFields),
          creatorIds: this.sanitizeArray(this.state.searchCustomerCreators),
          agencyId: -1,
        };

        const creatorSearch = !!search.creatorIds
          ? `, creatorIdsOperator: "Fait partie de", creatorIds:${search.creatorIds}`
          : '';

        res =
          '{customers(' +
          'socialReason:' +
          search.socialReason +
          ', socialReasonOperator:Contient, ' +
          'dateCreateStart:' +
          search.dateCreateStart +
          ', dateCreateEnd:' +
          search.dateCreateEnd +
          ', dateCreateOperator:' +
          search.dateCreateOperator +
          ', ' +
          'termination:' +
          search.termination +
          ', ' +
          'liquidation:' +
          search.liquidation +
          creatorSearch +
          ', professionalFieldIdsOperator: "Fait partie de", professionalFieldIds:' +
          search.professionalFieldIds +
          ', agencyId:' +
          search.agencyId +
          ', offset:' +
          itemsPerPage['book'] * offsetNb +
          ', limit:' +
          itemsPerPage['book'] +
          '){ hasMore, items{ id, dateCreate, deals{ id, name }, installationSite{ socialReason }, creator{ user{ id,username } }, typeMaintenance, technicalInformation } } }';
        break;
    }

    return res;
  };

  refreshSearchContact(offsetNb) {
    this.setState({ pendingHasMoreContact: true });
    let queryURL = apiContact;
    queryURL += this.getGraphQL('contact', offsetNb);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['contacts']['items']) {
            this.setState({
              offsetContact: offsetNb, // increment or reset the current offset
              hasMoreContact: data['data']['contacts']['hasMore'],
              pendingHasMoreContact: false,
              dataContact:
                offsetNb > 0
                  ? this.state.dataContact.concat(data['data']['contacts']['items'])
                  : data['data']['contacts']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch contact search: \n' + error);
        }.bind(this)
      );
  }

  refreshSearchCustomer(offsetNb) {
    this.setState({ pendingHasMoreCustomer: true });
    let queryURL = apiCustomer;
    queryURL += this.getGraphQL('customer', offsetNb);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['customers']) {
            this.setState({
              offsetCustomer: offsetNb, // increment or reset the current offset
              hasMoreCustomer: data['data']['customers']['hasMore'],
              pendingHasMoreCustomer: false,
              dataCustomer:
                offsetNb > 0
                  ? this.state.dataCustomer.concat(data['data']['customers']['items'])
                  : data['data']['customers']['items'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch customer search: \n' + error);
        }.bind(this)
      );
  }

  seeMore(type) {
    switch (type) {
      case 'contact':
        this.refreshSearchContact(this.state.offsetContact + 1);
        break;
      case 'customer':
        this.refreshSearchCustomer(this.state.offsetCustomer + 1);
        break;
    }
  }

  filter() {
    this.toggleAppViewNavExtended();

    switch (this.state.selectedView) {
      case 1: // Contact
        this.refreshSearchContact(0);
        break;
      case 2: // Customer
        this.refreshSearchCustomer(0);
        break;
    }
  }

  resetFilter() {
    this.setState({
      // CONTACT /////////////////////////////////////////////
      searchContactName: '',
      searchContactDateCreateStart: null,
      searchContactDateCreateEnd: null,
      searchContactPhone: '',
      searchContactEmail: '',
      searchContactJob: '',
      searchContactCompanyName: '',
      searchContactAgencyId: -1,
      searchContactOrigin: '',
      searchContactOrigins: [],
      searchContactCreator: '',
      searchContactCreators: [],
      // CUSTOMER ////////////////////////////////////////////
      searchCustomerSocialReason: '',
      searchCustomerDateCreateStart: null,
      searchCustomerDateCreateEnd: null,
      searchCustomerTermination: false,
      searchCustomerLiquidation: false,
      searchCustomerProfessionalField: '',
      searchCustomerProfessionalFields: [],
      searchCustomerCreator: '',
      searchCustomerCreators: [],
      searchCustomerAgencyId: -1,
    });
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    const { dataContact } = this.state;
    const { dataCustomer } = this.state;

    let noContact =
      this.state.dataContact != undefined && this.state.dataContact.length === 0 ? <span>Aucun résultat.</span> : '';
    let noCustomer =
      this.state.dataCustomer != undefined && this.state.dataCustomer.length === 0 ? <span>Aucun résultat.</span> : '';

    const styles = {
      image: {
        width: '15px',
      },
    };

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Contacts';
        break;
      case 2:
        viewName = 'Clients';
        break;
      case 3:
        viewName = 'Affaires';
        break;
    }

    let searchForm = null;
    switch (this.state.selectedView) {
      case 1:
        searchForm = (
          <div className={'appViewNavMenu-form-scroll'}>
            <div className='form-group'>
              <label>Nom</label>
              <input
                name='searchContactName'
                value={this.state.searchContactName}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Nom du contact'
              />
            </div>
            <div className='form-group'>
              <label>
                Date de création <i>(Rentrez date début -> fin)</i>
              </label>
              <div id='stat-aside-header-dates' className='alignHorizontal'>
                <DatePicker
                  calendarContainer={this}
                  value={this.state.searchContactDateCreateStart}
                  onChange={(value, formattedValue) =>
                    this.handleDateChange('searchContactDateCreateStart', value, formattedValue)
                  }
                  dateFormat='YYYY-MM-DD'
                />
                <span className='icon icon-arrow-right'></span>
                <DatePicker
                  calendarContainer={this}
                  value={this.state.searchContactDateCreateEnd}
                  onChange={(value, formattedValue) =>
                    this.handleDateChange('searchContactDateCreateEnd', value, formattedValue)
                  }
                  dateFormat='YYYY-MM-DD'
                />
              </div>
            </div>
            <div className='form-group'>
              <label>Téléphone</label>
              <input
                name='searchContactPhone'
                value={this.state.searchContactPhone}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Téléphone du contact'
              />
            </div>
            <div className='form-group'>
              <label>Email</label>
              <input
                name='searchContactEmail'
                value={this.state.searchContactEmail}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Email du contact'
              />
            </div>
            <div className='form-group'>
              <label>Job</label>
              <input
                name='searchContactJob'
                value={this.state.searchContactJob}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Job du contact'
              />
            </div>
            <div className='form-group'>
              <label>Nom d'entreprise</label>
              <input
                name='searchContactCompanyName'
                value={this.state.searchContactCompanyName}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Entreprise du contact'
              />
            </div>
            <div className='form-group'>
              <label>Origine</label>
              <AsyncSelect
                onChange={(val) => this.handleInputSelectMultiChange('searchContactOrigin', val)}
                value={this.state.searchContactOrigin}
                multi={true}
                cacheOptions={false}
                defaultOptions
                autoload={false}
                loadOptions={this.asyncOrigin}
                ignoreCase={false}
                filterOption={this.filterSelect}
              />
            </div>
            <div className='form-group'>
              <label>Créateur</label>
              <AsyncSelect
                onChange={(val) => this.handleInputSelectMultiChange('searchContactCreator', val)}
                value={this.state.searchContactCreator}
                multi={true}
                cacheOptions={false}
                defaultOptions
                autoload={false}
                loadOptions={this.asyncEmployee}
                ignoreCase={false}
                filterOption={this.filterSelect}
              />
            </div>
          </div>
        );
        break;
      case 2:
        searchForm = (
          <div className={'appViewNavMenu-form-scroll'}>
            <div className='form-group'>
              <label>Raison sociale</label>
              <input
                name='searchCustomerSocialReason'
                value={this.state.searchCustomerSocialReason}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Raison sociale du client'
              />
            </div>
            <div className='form-group'>
              <label>
                Date de création <i>(Rentrez date début -> fin)</i>
              </label>
              <div id='stat-aside-header-dates' className='alignHorizontal'>
                <DatePicker
                  calendarContainer={this}
                  value={this.state.searchCustomerDateCreateStart}
                  onChange={(value, formattedValue) =>
                    this.handleDateChange('searchCustomerDateCreateStart', value, formattedValue)
                  }
                  dateFormat='YYYY-MM-DD'
                />
                <span className='icon icon-arrow-right'></span>
                <DatePicker
                  calendarContainer={this}
                  value={this.state.searchCustomerDateCreateEnd}
                  onChange={(value, formattedValue) =>
                    this.handleDateChange('searchCustomerDateCreateEnd', value, formattedValue)
                  }
                  dateFormat='YYYY-MM-DD'
                />
              </div>
            </div>
            <div className='form-group'>
              <label className='input-check'>
                <input
                  name='searchCustomerTermination'
                  checked={this.state.searchCustomerTermination}
                  onChange={this.handleInputChange}
                  type='checkbox'
                  className=''
                />
                <span>Résilié</span>
              </label>

              <label className='input-check'>
                <input
                  name='searchCustomerLiquidation'
                  checked={this.state.searchCustomerLiquidation}
                  onChange={this.handleInputChange}
                  type='checkbox'
                  className=''
                />
                <span>Liquidation</span>
              </label>
            </div>
            <div className='form-group'>
              <label>Domaine d'activité</label>
              <AsyncSelect
                onChange={(val) => this.handleInputSelectMultiChange('searchCustomerProfessionalField', val)}
                value={this.state.searchCustomerProfessionalField}
                multi={true}
                cacheOptions={false}
                defaultOptions
                autoload={false}
                loadOptions={this.asyncProfessionalField}
                ignoreCase={false}
                filterOption={this.filterSelect}
              />
            </div>
            <div className='form-group'>
              <label>Créateur</label>
              <AsyncSelect
                onChange={(val) => this.handleInputSelectMultiChange('searchCustomerCreator', val)}
                value={this.state.searchCustomerCreator}
                multi={true}
                cacheOptions={false}
                defaultOptions
                autoload={false}
                loadOptions={this.asyncEmployee}
                ignoreCase={false}
                filterOption={this.filterSelect}
              />
            </div>
          </div>
        );
        break;
    }

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          title='Carnet'
          goBack={this.props.history.goBack}
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          appViewNavExtended={this.state.appViewNavExtended}
          xl
        >
          {this.state.selectedView !== 3 && (
            <div className={'appViewNavMenu-split'}>
              <div className={'appViewNavMenu-form'}>
                {searchForm}
                <div className={'appViewNavMenu-form-control'}>
                  <button onClick={() => this.resetFilter()} type='button' className='btn btn-sm btn-outline-success'>
                    <span className={'icon icon-erase'} />
                  </button>
                  <button onClick={() => this.filter()} type='button' className='btn btn-sm btn-outline-success'>
                    <span className='icon icon-magnifying-glass' />
                    Filtrer
                  </button>
                </div>
              </div>
              <div className={'appViewNavMenu-alignRight'}>
                <button
                  onClick={() => this.openModal('contact')}
                  type='button'
                  className='btn btn-sm btn-outline-success'
                >
                  <span className='icon icon-plus'>Contact</span>
                </button>
              </div>
            </div>
          )}
        </SubNavBar>

        <div id='appViewContent'>
          <div className='timeline menu'>
            <div className='timeline-flex'>
              <div
                onClick={() => this.switchStep(1)}
                className={'prep-step-number ' + (this.state.selectedView === 1 ? 'selected' : '')}
              >
                <img style={styles.image} src={bookIcon} />
              </div>
              <div
                onClick={() => this.switchStep(2)}
                className={'prep-step-number ' + (this.state.selectedView === 2 ? 'selected' : '')}
              >
                <img style={styles.image} src={clerkWithTieIcon} />
              </div>
              <div
                onClick={() => this.switchStep(3)}
                className={'prep-step-number ' + (this.state.selectedView === 3 ? 'selected' : '')}
              >
                <img style={styles.image} src={dealIcon} />
              </div>
            </div>
          </div>
          <div className='timeline-step-name'>
            <h3>{viewName}</h3>
          </div>

          {this.state.selectedView === 1 && (
            <div>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Créé le</th>
                    <th>Origine</th>
                    <th>Créateur</th>
                    <th>Supprimer</th>
                  </tr>
                </thead>
                <tbody>
                  {dataContact ? (
                    dataContact.map((data, i) => (
                      <tr key={i}>
                        <td>
                          <Link to={linkToContact + data.id}>
                            <span>{data.name + ' ' + data.lastname.toUpperCase()} </span>
                          </Link>
                        </td>
                        <td>
                          <span>{moment(data.dateCreate).format('DD-MM-YY')}</span>
                        </td>
                        <td>
                          <span>{data.origin ? data.origin.labelOrigin : '__'}</span>
                        </td>
                        <td>
                          {data.creator ? (
                            <Link to={linkToUser + data.creator.user.id}>
                              <span>{'@' + data.creator.user.username}</span>
                            </Link>
                          ) : (
                            <span>Non-renseigné</span>
                          )}
                        </td>
                        <td>
                          <button
                            onClick={(id, name) =>
                              this.openModalDeleteContact(data.id, data.name + ' ' + data.lastname.toUpperCase())
                            }
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-cross'></span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <li className='list-group-item'>Chargement...</li>
                  )}
                </tbody>
              </table>
              {this.state.hasMoreContact && (
                <div className='list-see-more'>
                  {this.state.pendingHasMoreContact ? (
                    <img src={ringAnim} />
                  ) : (
                    <button
                      onClick={() => this.seeMore('contact')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className=''>Voir plus</span>
                    </button>
                  )}
                </div>
              )}
              {noContact}
            </div>
          )}

          {this.state.selectedView === 2 && (
            <div>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Créé le</th>
                    <th>Statut</th>
                    <th>Créateur</th>
                  </tr>
                </thead>
                <tbody>
                  {dataCustomer ? (
                    dataCustomer.map((data, i) => (
                      <tr key={i}>
                        <td>
                          <Link to={linkToCustomer + data.id}>
                            <span>{data.installationSite.socialReason}</span>
                          </Link>
                        </td>
                        <td>
                          <span>{moment(data.dateCreate).format('DD-MM-YY')}</span>
                        </td>
                        <td>
                          <span>{data.deals && data.deals.length > 0 ? 'Client' : 'Prospect'}</span>
                        </td>
                        <td>
                          {data.creator ? (
                            <Link to={linkToUser + data.creator.user.id}>
                              <span>{'@' + data.creator.user.username}</span>
                            </Link>
                          ) : (
                            <span>Non-renseigné</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <li className='list-group-item'>Chargement...</li>
                  )}
                </tbody>
              </table>
              {this.state.hasMoreCustomer && (
                <div className='list-see-more'>
                  {this.state.pendingHasMoreCustomer ? (
                    <img src={ringAnim} />
                  ) : (
                    <button
                      onClick={() => this.seeMore('customer')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className=''>Voir plus</span>
                    </button>
                  )}
                </div>
              )}
              {noCustomer}
            </div>
          )}

          {this.state.selectedView === 3 && <Deals />}
        </div>

        <ModalContactPost
          openToast={this.props.openToast}
          className='myModal'
          isOpen={this.state.isModalPostContactOpen}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        ></ModalContactPost>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteContactOpen}
          onSubmit={this.deleteContact}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteCustomerOpen}
          onSubmit={this.deleteCustomer}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>
      </div>
    );
  }

  switchStep(newStep) {
    this.setState({
      selectedView: newStep,
    });
    this.resetFilter();
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalPostContactOpen: false,
      isModalDeleteContactOpen: false,
      isModalDeleteCustomerOpen: false,
    });
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'contact':
        toOpen = 'isModalPostContactOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  openModalDeleteContact(contactToDeleteId, contactName) {
    let modalText = {
      title: 'Supprimer un contact',
      message: 'Vous aller supprimer le contact ' + contactName,
    };
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteContactOpen: true,
      textModal: modalText,
      contactToDeleteId: contactToDeleteId,
    });
  }
  openModalDeleteCustomer(customerToDeleteId, customerName) {
    let modalText = {
      title: 'Supprimer un client',
      message: 'Vous aller supprimer le client ' + customerName,
    };
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteCustomerOpen: true,
      textModal: modalText,
      customerToDeleteId: customerToDeleteId,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    switch (type) {
      case 'contact':
        messageLabel = 'contact';
        break;
    }
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès création ' + messageLabel);
          this.componentDidMount();
          if (type === 'contact') {
            this.setState({ selectedView: 1 });
          }
        } else {
          this.props.openToast(false, 'Erreur création ' + messageLabel + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  deleteContact() {
    let queryURL = apiContact;
    let json = {
      contact: {
        id: this.state.contactToDeleteId,
      },
    };
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['isValid'] == true) {
            this.componentDidMount();
            this.setState({ selectedView: 1 });
            this.props.openToast(true, 'Le contact a bien été supprimé');
          } else {
            this.props.openToast(false, 'Erreur suppression du contact');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch delete contact: \n' + error);
          this.props.openToast(false, 'Suppression impossible');
        }.bind(this)
      );
  }

  deleteCustomer() {
    let queryURL = apiCustomer;
    queryURL += "{'customer'{'id':" + encodeURIComponent(this.state.customerToDeleteId) + '}}';
    this.props
      .authFetch(encodeURIComponent(queryURL), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['isValid'] == true) {
            this.componentDidMount();
            this.setState({ selectedView: 2 });
            this.props.openToast(true, 'Le client a bien été supprimé');
          } else {
            this.props.openToast(false, 'Erreur suppression du client');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch delete customer: \n' + error);
          this.props.openToast(false, 'Suppression impossible');
        }.bind(this)
      );
  }
}

export default withAuth(Book);
